export const WEATHER_API_URL = "https://api.weatherapi.com/v1/forecast.json";
export const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;